import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import VocabularyApp from "./payment";
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import './i18n';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Routes>
            <Route path={'/'} element={<VocabularyApp/>}/>
        </Routes>
    </BrowserRouter>
);